import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bcac-modal-form',
  templateUrl: './modal-form.component.html',
  styleUrls: ['./modal-form.component.scss']
})
export class ModalFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
